export const REQUIRED_LABELS = ['FACE', 'SEX_1', 'SEX_2'];

export const hasValidBox = (box) => (
  !!box
  && Number.isFinite(box.x1)
  && Number.isFinite(box.x2)
  && Number.isFinite(box.y1)
  && Number.isFinite(box.y2)
);

export const isTannerStimulus = (stimulus) => (
  stimulus?.type === 'tanner'
  || (stimulus?.control == null && !!stimulus?.gender)
);

export const isMissingRequiredLabels = (stimulus) => {
  const labels = stimulus?.labels || {};
  return REQUIRED_LABELS.some((name) => !hasValidBox(labels[name]));
};

export const isLabelingComplete = (stimulus) => (
  stimulus?.labeling_complete === true || !isMissingRequiredLabels(stimulus)
);

export const isLabelingIncomplete = (stimulus) => !isLabelingComplete(stimulus);

export const isActiveLabelingWork = (stimulus) => (
  isTannerStimulus(stimulus)
  && stimulus?.enabled !== false
  && isLabelingIncomplete(stimulus)
);

// Orders a labeling queue so items from a just-uploaded batch come first,
// preserving relative order within each group. Used by both the queue list and
// the detail view so batch labeling stays in sequence across navigation.
export const orderBatchFirst = (list, batchHashes, getHash = (item) => item) => {
  if (!Array.isArray(batchHashes) || batchHashes.length === 0) {
    return list;
  }
  const batchSet = new Set(batchHashes);
  return [
    ...list.filter((item) => batchSet.has(getHash(item))),
    ...list.filter((item) => !batchSet.has(getHash(item))),
  ];
};
